import { areasApi } from "activity/sub_modules/areas/api/Areas.api";
import { CommonApi } from "api/common.api";
import React from "react";

const useGetAreasHook = () => {
  const [area, setArea] = React.useState("");
  const [search, setSearch] = React.useState("");

  const debounceRef = React.useRef<NodeJS.Timeout>();

  const { data, isFetching } = areasApi.useFetchAreasQuery({ search });

  React.useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => setSearch(area), 500);
  }, [area]);

  return {
    area,
    setArea,
    isFetching,
    data:
      data?.result?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || [],
  };
};

export default useGetAreasHook;
